import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/internal/Observable";
import {FileImportOrlen} from "../types/data-import/data-import-orlen";

@Injectable({
  providedIn: 'root',
})
export class DataImportService {
  constructor(private http: HttpClient) {}

  addOrlen(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<any>('api/data-import/orlen', formData);
  }

  addAcmi(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<any>('api/data-import/acmi', formData);
  }
}
